module.exports = __webpack_public_path__ + "double-uno-desktop.jpg";